import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { focusStyles } from "@store/theme/common/mixins/typography";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export const sideMenuWrapperStyles = (padding = "0.7em 0") => {
    return css`
        font-size: ${TYPOGRAPHY.size.smaller};
        line-height: ${TYPOGRAPHY.lineHeight.small};
        padding: ${padding};
    `;
};

export const sideMenuLinkStyles = (padding = "0.7em 1em") => {
    return css`
        ${focusStyles()}
        width: 100%;
        padding: ${padding};
        font-weight: ${TYPOGRAPHY.weight.base};
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        outline-offset: -${getProp("theme.focus.width")};

        &:hover {
            text-decoration: underline;
        }
    `;
};

export const sideMenuLinkActiveStyles = () => {
    return css`
        ${focusStyles()}
        border-left-color: ${getColor("primary")};
        color: ${getColor("text.link")};
        &:hover {
            text-decoration: none;
        }
    `;
};
